var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 13.2c-.2-.2-.4 0-.4.2v2.5H3.2c-.1 0-.2.1-.2.2v1.7c0 .1.1.2.2.2h13.7v2.5c0 .2.3.3.4.2l3.7-3.6c.1-.1.1-.3 0-.4l-3.7-3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 3.3c.2-.2.4 0 .4.2V6h13.7c.1 0 .2.1.2.2V8c0 .1-.1.2-.2.2H7.2v2.5c0 .2-.3.3-.4.2L3 7.3c-.1-.1-.1-.2 0-.4l3.7-3.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/Swap.70de460a.svg";
export { ForwardRef as ReactComponent };